import {IGTMEventLeadForm} from "../../../tracking/google_tag_manager/gtm_event_form_open";
import {IAmplitudeLeadFormTrackingContext} from "./IAmplitudeLeadFormEventTracking";

export interface IApplicationModalAmplitudeOnlyOpenTracking {
    amplitude: IAmplitudeLeadFormTrackingContext;
}

export interface IApplicationModalOpenTrackingWithAmplitude {
    gtm: IGTMEventLeadForm;
    amplitude: IAmplitudeLeadFormTrackingContext;
}

export type ApplicationModalOpenTrackingInput = IGTMEventLeadForm | IApplicationModalOpenTrackingWithAmplitude | IApplicationModalAmplitudeOnlyOpenTracking;

export const isGtmEventLeadForm = (tracking: ApplicationModalOpenTrackingInput): tracking is IGTMEventLeadForm => {
    return "clickText" in tracking && "source" in tracking && "vendorName" in tracking && "offerName" in tracking;
};

export const isApplicationModalOpenTrackingWithAmplitude = (
    tracking: ApplicationModalOpenTrackingInput
): tracking is IApplicationModalOpenTrackingWithAmplitude => {
    return "gtm" in tracking && "amplitude" in tracking;
};

export const isApplicationModalAmplitudeOnlyOpenTracking = (
    tracking: ApplicationModalOpenTrackingInput
): tracking is IApplicationModalAmplitudeOnlyOpenTracking => {
    return "amplitude" in tracking && !isApplicationModalOpenTrackingWithAmplitude(tracking);
};
import {IGTMEventLeadForm} from "../../../tracking/google_tag_manager/gtm_event_form_open";
import {IAmplitudeLeadFormTrackingContext} from "./IAmplitudeLeadFormEventTracking";

export interface IApplicationModalAmplitudeOnlyOpenTracking {
    amplitude: IAmplitudeLeadFormTrackingContext;
}

export interface IApplicationModalOpenTrackingWithAmplitude {
    gtm: IGTMEventLeadForm;
    amplitude: IAmplitudeLeadFormTrackingContext;
}

export type ApplicationModalOpenTrackingInput = IGTMEventLeadForm | IApplicationModalOpenTrackingWithAmplitude | IApplicationModalAmplitudeOnlyOpenTracking;

export const isGtmEventLeadForm = (tracking: ApplicationModalOpenTrackingInput): tracking is IGTMEventLeadForm => {
    return "clickText" in tracking && "source" in tracking && "vendorName" in tracking && "offerName" in tracking;
};

export const isApplicationModalOpenTrackingWithAmplitude = (
    tracking: ApplicationModalOpenTrackingInput
): tracking is IApplicationModalOpenTrackingWithAmplitude => {
    return "gtm" in tracking && "amplitude" in tracking;
};

export const isApplicationModalAmplitudeOnlyOpenTracking = (
    tracking: ApplicationModalOpenTrackingInput
): tracking is IApplicationModalAmplitudeOnlyOpenTracking => {
    return "amplitude" in tracking && !isApplicationModalOpenTrackingWithAmplitude(tracking);
};
